import UnitSection from "./../UnitSection";
import LessonTile from "./../VocabTile";
import { openLessonPopup } from "./../openPopup";

// Group lessons by their sequence number (same sequence = same unit)
function groupByUnit(tiles) {
    const units = {};
    tiles.forEach(tile => {
        const unit = tile.sequence;
        if (!units[unit]) units[unit] = [];
        units[unit].push(tile);
    });
    return units;
}

function TestDash({ tiles, lang_id }) {
    const units = groupByUnit(tiles);
    const sortedUnitNumbers = Object.keys(units).map(Number).sort((a, b) => a - b);

    // CREATE UNIT MAP: { unitNum : boolean }
    let lockUnit = {};
    let lockNext = false;
    let prevMandatoryTilesCompleted = true;
    sortedUnitNumbers.forEach(unitNum => {
        if (lockNext) {
            lockUnit[unitNum] = true;
            return;
        }
        lockUnit[unitNum] = !prevMandatoryTilesCompleted;
        lockNext = !prevMandatoryTilesCompleted;

        // Determine if all the mandatory tiles in the unit are completed
        const mandatoryTiles = units[unitNum].filter(t => t.mandatory);
        prevMandatoryTilesCompleted = mandatoryTiles.every(t => t.completed === 1);
    });

    return (
        <div className="dashboard-vocab-root dashboard-test-root">
            <div className="dashboard-units-list">
                {sortedUnitNumbers.map(unitNum => {
                    return (
                        <UnitSection
                            key={unitNum}
                            unitNumber={unitNum}
                            className="dashboard-unit-section--test"
                        >
                            <div className="dashboard-unit-tiles-grid">
                                {units[unitNum].map(tile => {
                                    tile.locked = lockUnit[unitNum];

                                    return (
                                        <LessonTile
                                            key={tile.tile_id}
                                            id={tile.tile_id}
                                            title={tile.title}
                                            subtitle={tile.subtitle}
                                            sequence={tile.sequence}
                                            mandatory={tile.mandatory}
                                            completed={tile.completed}
                                            locked={tile.locked}
                                            familiarity_score={tile.familiarity_score}
                                            isTest={true}
                                            onSee={() => {
                                                openLessonPopup(tile.tile_id, () => {
                                                    window.location.href = `/testing?lesson_id=${tile.tile_id}`;
                                                });
                                            }}
                                            buttonText={tile.completed ? "Retake Test" : "Start Test"}
                                        />
                                    );
                                })}
                            </div>
                        </UnitSection>
                    );
                })}
            </div>
        </div>
    );
}

export default TestDash;
